import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import "../../style.css";
import "bootstrap/dist/css/bootstrap.min.css";

import Techstack from "./Techstack";
import Aboutcard from "./AboutCard";
import laptopImg from "../../Assets/about.png";

function About() {
  return (
    <Container fluid className="about-section">
      <Particle />
      <Container>
        <Row style={{ justifyContent: "center", padding: "10px" }}>
          <Col
            md={7}
            style={{
              justifyContent: "center",
              paddingTop: "30px",
              paddingBottom: "50px",
            }}
          >
            <h1 style={{ fontSize: "2.1em", paddingBottom: "20px" }}>
              Know Who <strong className="purple">I'M</strong>
            </h1>
            <Aboutcard />
          </Col>
          <Col
            md={5}
            style={{ paddingTop: "120px", paddingBottom: "50px" }}
            className="about-img"
          >
            <img src={laptopImg} alt="about" className="img-fluid" />
          </Col>
        </Row>
        <h1 className="project-heading">
          My technical <strong className="purple">Skillset </strong>
        </h1>
        <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
          <Techstack iconName="devicon-graphql-plain" />
          <Techstack iconName="devicon-react-original-wordmark" />
          <Techstack iconName="devicon-materialui-plain" />
          <Techstack iconName="devicon-python-plain-wordmark " />
          <Techstack iconName="devicon-css3-plain" />
          <Techstack iconName="devicon-javascript-plain" />
          <Techstack iconName="devicon-typescript-plain" />
          <Techstack iconName="devicon-nodejs-plain" />
          <Techstack iconName="devicon-android-plain" />
          <Techstack iconName="devicon-java-plain" />
          <Techstack iconName="devicon-nextjs-original" />
          <Techstack iconName="devicon-cplusplus-line" />
          <Techstack iconName="devicon-csharp-line" />
          <Techstack iconName="devicon-git-plain-wordmark" />
          <Techstack iconName="devicon-bootstrap-plain-wordmark" />
          <Techstack iconName="devicon-firebase-plain" />
          <Techstack iconName="devicon-amazonwebservices-original" />
        
        </Row>
        <h1 className="project-heading">
          <strong className="purple">Tools</strong> I use
        </h1>
        <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
          <Techstack iconName="cib-visual-studio-code" />
          <Techstack iconName="cib-anaconda" />
          <Techstack iconName="cib-amazon-aws" />
        </Row>
      </Container>
    </Container>
  );
}

export default About;
